<div class="right-buttons">
  <div class="icons-buttons-row">
    <!-- Icone -->
    <div class="icons-group">
      @if (merchantService.accessAllowed !== true) {
        <mat-icon class="menuIconRight" svgIcon="user" (click)="navigateToSandbox()"></mat-icon>
      }
      @if (merchantService.accessAllowed) {
        <mat-icon class="menuIconRight" svgIcon="logout" (click)="logout()"></mat-icon>
      }
      <mat-icon class="menuIconRight" svgIcon="email" (click)="redirect('https://www.worldlineitalia.it/contatti/')"></mat-icon>
    </div>

    <!-- Pulsante Richiedi ora -->
    <div class="buttons-group">
      @if (merchantService.accessAllowed === true) {
        <button mat-raised-button class="btn-active-green" (click)="leads()">Richiedi ora</button>
      }
      @if (merchantService.accessAllowed !== true) {
      <button mat-raised-button class="btn-active-green" style="margin: 0px 5px;" i18n='@@btn-Register'
        (click)="navigateTo()">Registrati</button>
      }
    </div>

    <!-- Lingue -->
    <div class="langs-group">
      <button class="lang-button" (click)="onChangeLanguage('it')" [ngStyle]="{'opacity' : currentLanguage === 'it' ? '1' : '0.5'}">
        <img alt="Italiano" src="assets/flags/it-flag.png" class="flag-lang">
      </button>
      <button class="lang-button" (click)="onChangeLanguage('en')" [ngStyle]="{'opacity' : currentLanguage === 'en' ? '1' : '0.5'}">
        <img alt="English" src="assets/flags/en-flag.png" class="flag-lang">
      </button>
    </div>
  </div>
</div>
